<template>
  <span>
    <template v-for="(segment, index) in segments">
      <span
        v-if="segment.match"
        :key="'match-' + index"
        class="audit-search-highlight">
        {{ segment.text }}
      </span>
      <span v-else :key="'text-' + index">{{ segment.text }}</span>
    </template>
  </span>
</template>

<script>
export default {
  name: 'AuditLogHighlight',
  props: {
    text: {
      type: [String, Number],
      default: ''
    },
    query: {
      type: String,
      default: ''
    }
  },
  computed: {
    segments () {
      const text = String(this.text == null ? '' : this.text)
      const query = this.query.trim()
      if (!query) {
        return [{ text, match: false }]
      }

      const segments = []
      const normalizedText = text.toLocaleLowerCase()
      const normalizedQuery = query.toLocaleLowerCase()
      let offset = 0
      let matchIndex = normalizedText.indexOf(normalizedQuery, offset)

      while (matchIndex !== -1) {
        if (matchIndex > offset) {
          segments.push({ text: text.slice(offset, matchIndex), match: false })
        }
        const matchEnd = matchIndex + query.length
        segments.push({ text: text.slice(matchIndex, matchEnd), match: true })
        offset = matchEnd
        matchIndex = normalizedText.indexOf(normalizedQuery, offset)
      }

      if (offset < text.length) {
        segments.push({ text: text.slice(offset), match: false })
      }
      return segments.length ? segments : [{ text, match: false }]
    }
  }
}
</script>

<style scoped>
.audit-search-highlight {
  padding: 0 2px;
  border-radius: 2px;
  background: #ffc107;
  color: #1b1e21;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}
</style>
